import styled from '@emotion/styled';
import tw from 'twin.macro';
import { TextItemContainer } from './components/N5050BlockTextRow/N5050BlockTextRow.styles';
import Link from '@/components/Link/Link';
import { StyledContainer } from '../RichTextBlock/RichTextBlock.styles';

export const StyledSection = styled.section``;

export const StyledContainerN5050 = styled.div`
  ${tw`lg:container`}
  ${tw`container-stack-context`}
  ${tw`flex flex-col items-center`}
  ${tw`px-1 lg:px-0`}
`;

export const StyledRow = styled.section<{
  background_color?: Queries.kontent_item_n5050_block_image_and_text_row_elements_background_color_enum;
  image_direction:
    | Queries.kontent_item_n5050_block_image_and_text_row_elements_image_direction_enum
    | undefined;
}>`
  ${({ background_color }) =>
    background_color ? tw`md:grid-cols-12 md:gap-x-4` : tw`lg:grid-cols-12 lg:gap-x-4`}
  ${tw`grid grid-flow-row-dense gap-x-8`}
  ${tw`my-4 lg:my-8 last-of-type:mb-0`}
  ${tw`first-of-type:mt-0`}
  ${tw`w-full`}
  ${tw`relative`}
  ${tw`py-1`}
  
  ${TextItemContainer} {
    ${tw`mb-4 lg:mb-0`}
    &:last-of-type {
      ${tw`mb-0 mt-4 lg:mt-0`}
    }
  }
  ${StyledContainer} {
    ${tw`m-0`}
    ${tw`max-w-[100%]`}
    ${tw`md:container`}
  }
  &:last-of-type {
    ${tw`mb-0`}
  }
  &:before {
    ${tw`-z-10`}
    ${tw`content-['']`}
    ${tw`absolute`} 
    ${tw`h-full w-full md:w-3/4 lg:w-full`}
    ${({ image_direction }) =>
      image_direction === 'left' ? tw`right-0 bottom-0` : tw`left-0 bottom-0`}
    ${({ background_color }) =>
      background_color === 'stroke' && tw`border-2 lg:w-10/12 border-ui-colours-ui3 p-2`}

    ${({ background_color }) =>
      background_color === 'ghost_white' && tw`bg-ui-colours-ui1 lg:w-10/12`}
    ${tw`rounded-2xl`}
  }
`;

export const StyledHeader = styled.div`
  ${tw`col-span-4`}
  ${tw`grid grid-cols-4 gap-x-2 gap-y-8 md:grid-cols-8 md:gap-3 lg:grid-cols-12 lg:gap-4`}
  ${tw`auto-rows-min`}
  ${tw`mb-8`}
`;

export const StyledHeaderContent = styled.div`
  ${tw`col-span-4 md:col-span-8 lg:col-span-8 lg:col-start-3`}
  ${tw`flex flex-col items-center text-center`}
`;

export const StyledEyebrow = styled.span`
  ${tw`font-inter font-semi-bold uppercase`}
  ${tw`text-tag-m text-primary-p1`}
  ${tw`mb-2`}
`;

export const StyledHeadline = styled.h2`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-mobile-display-xl text-secondary-s1 lg:text-display-xl`}
`;

export const StyledDescription = styled.p`
  ${tw`font-inter`}
  ${tw`text-body-l text-primary-p1`}
  ${tw`mt-5 lg:mt-3`}
`;

export const StyledButton = styled(Link)`
  ${tw`mt-5`}
`;
